import type { InjectionKey } from 'vue';

interface SegmentedControlContext {
  isValueSelected: (value: any) => boolean;
  selectValue: (value: any) => void;
}

export const SEGMENTED_CONTROL_CONTEXT: InjectionKey<SegmentedControlContext> = Symbol(
  __DEV__ ? 'SegmentedControl context' : '',
);
